import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

const MyProfilePartnersStyled = styled.div`
   .containerHeader {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    max-width: 100%;
    /* Sin tarjeta blanca ni padding propio: el de la página (30px 60px), como en el resto de páginas de admin */
    padding: 0;
    gap: 50px;
  }

  .sectionSecond {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 15px;

    & h2 {
      font-size: 20px; /* título de página de Velora, igual que candidatos y favoritos */
      font-weight: 600;
      line-height: 1.2;
      color: ${tokens.color.text.primary};
      margin-bottom: 0;
    }
    & h5 {
      font-size: 14px;
      font-weight: 400;
      color: ${tokens.color.text.tertiary};
      line-height: inherit;
    }

    & p {
      font-weight: 400;
      color: #7a808d;
    }
  }

`

export default MyProfilePartnersStyled
